import i18n from "@/i18n.ts";
import { ApiEmployeeShort } from "@/types/employees/employee.types.ts";

export interface ApiNotificationInApp {
  icon_url?: string;
  emoji?: string;
  pre_title?: string;
  title?: string;
  caption?: string;
  button_title?: string;
  button_is_primary?: boolean;
  href?: string;
  blank?: boolean;
  show_close_button?: boolean;
  icon: string | null;
  icon_class: string | null;
}

export interface ApiNotificationWorkflowData {
  title: string | null;
  emoji: string | null;
  changes: Array<{
    title: string;
    table_title: string | null;
    value_before: string | null;
    value_after: string | null;
  }>;
  changes_hidden_count: number;
}

export interface ApiNotificationApprovalRequest {
  request_id: number;
  workflow_data: ApiNotificationWorkflowData | null;
}

export interface ApiNotification {
  id: number;
  notification_type: string;
  in_app?: ApiNotificationInApp;
  approval_request?: ApiNotificationApprovalRequest | null;
}

export interface ApiNotificationsFilter {
  page_number: number;
}

export interface ApiNotificationFull {
  notification: ApiNotification;
  author: ApiEmployeeShort;
}

export enum ApiNotificationChannelType {
  email = "email",
  slack = "slack",
  messenger = "messenger",
  in_app = "in-app",
  slack_channel = "slack_channel",
}

export interface NotificationSettings {
  time_off_all: ApiNotificationChannelType[];
  hiring_plan_all: ApiNotificationChannelType[];
  mention: ApiNotificationChannelType[];
  ats_comments_all: ApiNotificationChannelType[];
  event_all: ApiNotificationChannelType[];
  data_protection_response: ApiNotificationChannelType[];
  blog_post_all: ApiNotificationChannelType[];
  talent_surveys_all: ApiNotificationChannelType[];
  ats_feedbacks_all: ApiNotificationChannelType[];
  talent_performance_reviews_all: ApiNotificationChannelType[];
  goals_all: ApiNotificationChannelType[];
  goal_key_results_all: ApiNotificationChannelType[];
  task_all: ApiNotificationChannelType[];
  task_overdue: ApiNotificationChannelType[];
}

export interface ApiNotificationsSetting {
  notifications_setting: NotificationSettings;
}

export interface ApiNotificationsSettingPayload {
  notifications_setting: NotificationSettings;
}

export const getApiNotificationChannelTypeTitle = (type: ApiNotificationChannelType) => {
  switch (type) {
    case ApiNotificationChannelType.email:
      return "Email";
    case ApiNotificationChannelType.slack:
      return "Slack";
    case ApiNotificationChannelType.messenger:
      return i18n.t("core:messenger");
    case ApiNotificationChannelType.in_app:
      return i18n.t("core:in_app");
    case ApiNotificationChannelType.slack_channel:
      return i18n.t("blog:slack_channel");
  }
};
